const getCode = (state) => state.piiRetry.code;

const getFetchingPIIRetry = (state) => state.piiRetry.fetchingPIIRetry;

export default {
    getCode,
    getFetchingPIIRetry
};
